import { render, staticRenderFns } from "./HcpNotification.vue?vue&type=template&id=8eb746fc&scoped=true&"
import script from "./HcpNotification.vue?vue&type=script&lang=js&"
export * from "./HcpNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eb746fc",
  null
  
)

export default component.exports